interface FooterProps {
	htmlFooter: string;
}

const Footer = ({ htmlFooter }: FooterProps) => {
	return <div dangerouslySetInnerHTML={{ __html: htmlFooter }}></div>;
};

export default Footer;
